import { z } from 'zod'
import {
	ParentConnectionNameSchema,
	ParentConnectionSchema,
	UserIdSchema,
} from '#app/utils/zod-helpers.js'

const BaseUserRoleSchema = z.object({})

export const UserRoleCreateSchema = BaseUserRoleSchema.extend({
	create: z
		.array(
			z.object({
				role: ParentConnectionNameSchema,
			}),
		)
		.or(
			z.object({
				role: ParentConnectionNameSchema,
			}),
		),
})

export const UserRoleEditorCreateSchema = BaseUserRoleSchema.partial().extend({
	user: ParentConnectionSchema,
	role: ParentConnectionSchema,
})

export const UserRoleNameSchema = UserIdSchema.extend({
	roleName: z.string(),
})
